/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetProductDetailsByProductID,
    SaveProduct,
    UpdateProduct,
    GetProductCategoties,
    GetProductTypes,
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    saveFarmer,
    GetRouteByFactoryID
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetRouteByFactoryID(factoryID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;

}

async function GetProductDetailsByProductID(productID) {
    const response = await CommonGet('/api/Product/getProductDetailsByID', 'productID=' + productID);
    return response.data;

}

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupIDV2', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function SaveProduct(values, image) {

    var formdata = {
        ProductCode: values.productCode,
        ProductName: values.productName,
        ProductDescription: values.productDescription,
        ProductCategoryID: parseInt(values.productCategoryID),
        ProductTypeID: parseInt(values.productTypeID),
        IsActive: values.isActive,
        CreatedBy: 1,
        CreatedDate: new Date(),
        Image: image
    }

    const response = await CommonPost('/api/Product/SaveProduct', null, formdata);
    return response;

}

async function UpdateProduct(values, productID) {

    var formdata = {
        ProductID: parseInt(productID),
        ProductCode: values.productCode,
        ProductName: values.productName,
        ProductDescription: values.productDescription,
        ProductCategoryID: parseInt(values.productCategoryID),
        ProductTypeID: parseInt(values.productTypeID),
        Image: values.image,
        IsActive: values.isActive,
        ModifiedBy: 1,
        ModifiedDate: new Date(),
    }

    const response = await CommonPost('/api/Product/UpdateProduct', null, formdata);
    return response;

}

async function saveFarmer(bulkModel) {
    bulkModel.forEach(x => {
        x.mobileNumber = parseInt(x.mobileNumber)
    });
    const response = await CommonPost('/api/Farmer/SaveFarmerBulk', null, bulkModel);
    return response;
}